module.exports = __webpack_public_path__ + "static/media/Logo_ESPRIT.2b998c5c.png";